import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import AddressForm from "../../Assets/sc-client/Address/AddressForm";
import { CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import * as actions from '../store/profileActions';
import * as actionsAddress from '../../Assets/sc-client/Address/store/addressActions';
import { hasPermission } from "../../sc-utilities";
import { CancelToken } from 'axios';

const AddressInformation = props => {
    const { activeCustomerID, loggedUser, translations, updateUserAddress, tabValue, createUserAddress, permissions, onFetchAddresses } = props;
    const [editData, setEditData] = useState({ data: false, loading: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            let q = { UserID: loggedUser && loggedUser.UserID ? loggedUser.UserID : null }
            let result = await onFetchAddresses({ ActiveCustomerID: activeCustomerID, q: q }, { listSource: requestToken })
            setEditData({ data: result.data, loading: false })
        }
        if (tabValue === 1 && !editData.data) {
            fetchData();
        }

        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);

    const handleSubmit = async data => {
        let sendData = { ...data }
        sendData["ActiveCustomerID"] = activeCustomerID;
        sendData["Type"] = 'user';
        sendData["UserID"] = loggedUser.UserID;
        if (editData.data && editData.data.AddressID) {
            sendData["AddressID"] = editData.data.AddressID;
        }
        if (editData.data) {
            await updateUserAddress(sendData);
        }
        else {
            await createUserAddress(sendData);
        }
    }

    let initialValues = {
        City: editData.data && editData.data.City ? editData.data.City : '',
        Country: editData.data && editData.data.Country ? editData.data.Country : '',
        Street: editData.data && editData.data.Street ? editData.data.Street : '',
        StreetNumber: editData.data && editData.data.StreetNumber ? editData.data.StreetNumber : '',
        GLN: editData.data && editData.data.GLN ? editData.data.GLN : ''
    }

    let formSettings = {
        Validation: {
            City: Yup.string().notRequired(),
            Country: Yup.string().notRequired(),
            Street: Yup.string().notRequired(),
            StreetNumber: Yup.string().notRequired(),
            GLN: Yup.string().notRequired()
        },
        ButtonSubmit: hasPermission(permissions, 'address_save') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        !editData.loading ?
            <AddressForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                profile={true}
                translations={translations}
                permissions={editData.permissions}
            /> :
            <CircularProgress />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        loggedUser: state.core.login.user,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createUserAddress: data => dispatch(actionsAddress.createAddress(data)),
        updateUserAddress: data => dispatch(actionsAddress.editAddress(data)),
        onFetchAddresses: (data, options) => dispatch(actions.fetchAddresses(data, options)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddressInformation);
